import React from 'react';
import AboutPage from '../components/AboutPage';

const About = () => {
  return <AboutPage lang="fr" title="À propos du cours | Full Stack open" />;
};

export default About;
